// [EVENT-MODE] Inventor invitations disabled — companies cannot invite inventors
export default function InviteInventor({ onClose }) {
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold text-vault-navy">Invite Inventor</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-2xl leading-none">&times;</button>
        </div>
        <p className="text-sm text-gray-400">
          Inventor invitations are not available in event mode. Access is managed by the event admin.
        </p>
        <button
          onClick={onClose}
          className="mt-4 w-full py-2.5 border border-vault-border text-gray-600 font-medium rounded-lg hover:bg-gray-50"
        >
          Close
        </button>
      </div>
    </div>
  );
}
